"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPluginUrlBuilder = exports.getPluginUrlPrefix = exports.getPluginList = exports.applyConfig = void 0;
var _plugins = {};
var _pluginUrlPrefix = '/plugins/';
var _pluginUrlBuilder = function (pluginName) {
    return "/plugins/" + pluginName + "/index.js";
};
function applyConfig(config) {
    if (typeof config.pluginUrlPrefix === 'string') {
        _pluginUrlPrefix = config.pluginUrlPrefix;
    }
    if (typeof config.pluginUrlBuilder === 'function') {
        _pluginUrlBuilder = config.pluginUrlBuilder;
    }
}
exports.applyConfig = applyConfig;
/**
 * get all pluginList
 */
function getPluginList() {
    return _plugins;
}
exports.getPluginList = getPluginList;
/**
 * get all pluginUrlPrefix
 */
function getPluginUrlPrefix() {
    return _pluginUrlPrefix;
}
exports.getPluginUrlPrefix = getPluginUrlPrefix;
/**
 * Get plugin url builder
 * @default
 * (pluginName) => `/plugins/${pluginName}/index.js`
 */
function getPluginUrlBuilder(pluginName) {
    return _pluginUrlBuilder(pluginName);
}
exports.getPluginUrlBuilder = getPluginUrlBuilder;
